import React, { createContext, useCallback, useContext, useState } from 'react';

export interface ModalClosedContextValue {
  /** Increment to trigger DataGrid refresh (used internally) */
  refreshTrigger: number;
  /** Call when any modal/dialog closes (confirm or cancel) so grids refresh layout */
  notifyModalClosed: () => void;
}

const defaultValue: ModalClosedContextValue = {
  refreshTrigger: 0,
  notifyModalClosed: () => {},
};

export const ModalClosedContext = createContext<ModalClosedContextValue>(defaultValue);

export const ModalClosedProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const notifyModalClosed = useCallback(() => {
    setRefreshTrigger((t) => t + 1);
  }, []);
  const value: ModalClosedContextValue = { refreshTrigger, notifyModalClosed };
  return (
    <ModalClosedContext.Provider value={value}>{children}</ModalClosedContext.Provider>
  );
};

export const useModalClosedContext = (): ModalClosedContextValue => {
  const ctx = useContext(ModalClosedContext);
  return ctx ?? defaultValue;
};
